<!-- Entries -->
<div class="activities-list" *ngIf="!loading; else loadingSpinner">
  <div *ngIf="timeEntries.length === 0">No entries</div>
  <div class="activity-row" *ngFor="let entry of timeEntries">
    <!-- Project and Organization -->
    <div class="project-col">
      <div class="dark-text">{{ entry.projectName }}</div>
      <div class="sm-text">{{ entry.organizationName?.toLocaleUpperCase() }}</div>
      <div class="sm-text">{{ entry.taskName || 'No to-do' }}</div>
    </div>

    <!-- Reason -->
    <!-- <div class="reason-col">
      <div class="truncated-text" appTooltip [title]="entry.reason">{{ entry.reason }}</div>
    </div> -->

    <!-- Start Time -->
    <div class="start-time-col">
      <app-lozenge
        [subtle]="true"
        [type]="'aui-lozenge-new'"
        [label]="entry.startsAt | date : 'dd.MM.yyyy HH:mm:ss'"
      ></app-lozenge>
      <!-- {{ entry.startsAt | date : 'dd.MM.yyyy HH:mm:ss' }} -->
    </div>

    <!-- Duration -->
    <div class="duration-col">
      <app-lozenge [subtle]="true" [label]="entry.trackedAsString ?? 'No-duration'"></app-lozenge>
      <!-- {{ entry.trackedAsString }} -->
    </div>

    <!-- Actions -->
    <div class="actions-col">
      <app-button
        (clickHandler)="onActionClick($event, entry)"
        [id]="'link-time-entry-btn-' + entry.id"
        [iconClasses]="entry.jiraWorklogId ? 'delete' : ''"
        [iconType]="entry.jiraWorklogId ? IconTypes.Unlink : IconTypes.Link"
        [btnTitle]="entry.jiraWorklogId ? 'Unlink from Jira issue worklog' : 'Link as Jira issue worklog'"
      ></app-button>
    </div>
  </div>
</div>
<ng-template #loadingSpinner>
  <div class="aui-group spinner-center">
    <p>Fetching time entries...</p>
    <app-spinner></app-spinner>
  </div>
</ng-template>
